export default "__VITE_ASSET__BdHaGqbB__"